module.exports = __webpack_public_path__ + "img/23.989f059a.jpg";